import { Mail, Phone, Globe, MapPin, Clock } from 'lucide-react';
import LegalShell from './LegalShell';

const CONTACT_ITEMS = [
  {
    icon: Mail,
    label: 'Email PNC HR',
    value: 'admin@pncunique.com',
    href: 'mailto:admin@pncunique.com',
    note: 'Best for questions about your invitation, signing link or a completed document.',
    testId: 'contact-email',
  },
  {
    icon: Phone,
    label: 'Telephone',
    value: '0333 090 5024',
    href: 'tel:03330905024',
    note: 'Call us to verify an invitation before entering personal information.',
    testId: 'contact-phone',
  },
  {
    icon: Globe,
    label: 'Company website',
    value: 'www.pncunique.com',
    href: 'https://www.pncunique.com',
    note: 'Learn more about PNC UNIQUE LTD and the services we provide.',
    testId: 'contact-website',
  },
];

export default function ContactPage() {
  return (
    <LegalShell testId="contact-page" eyebrow="Legal" title="Contact">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
        {CONTACT_ITEMS.map(({ icon: Icon, label, value, href, note, testId }) => (
          <a
            key={label}
            data-testid={testId}
            href={href}
            target={href.startsWith('http') ? '_blank' : undefined}
            rel={href.startsWith('http') ? 'noreferrer' : undefined}
            className="pnc-card rounded-lg p-7 block hover:border-[#3A3A3A] transition-colors"
          >
            <Icon size={22} strokeWidth={2} className="text-[var(--silver)] mb-5" />
            <p className="field-label mb-2">{label}</p>
            <p className="serif text-lg text-[var(--text)] mb-3 break-all">{value}</p>
            <p className="text-sm text-[var(--muted)] leading-relaxed">{note}</p>
          </a>
        ))}
      </div>

      <div className="pnc-card rounded-lg p-7 sm:p-9">
        <div className="flex items-start gap-4">
          <MapPin size={22} strokeWidth={2} className="text-[var(--silver)] shrink-0 mt-1" />
          <div>
            <p className="field-label mb-3">Registered office</p>
            <p className="text-[15px] leading-7 text-[var(--muted)]">
              PNC UNIQUE LTD<br />
              Headlands House, 1 Kings Court<br />
              Kettering Parkway, Kettering<br />
              Northamptonshire, NN15 6WJ<br />
              Registered in England and Wales &middot; ICO Registration <span className="text-[var(--text)] font-semibold">ZB865873</span>
            </p>
          </div>
        </div>
      </div>

      <div className="pnc-card rounded-lg p-7 sm:p-9">
        <div className="flex items-start gap-4">
          <Clock size={22} strokeWidth={2} className="text-[var(--silver)] shrink-0 mt-1" />
          <div>
            <p className="field-label mb-3">Before you get in touch</p>
            <p className="text-[15px] leading-relaxed text-[var(--muted)]">
              PNC UNIQUE LTD will never request your signing link by telephone, and invitations are always
              sent from <strong className="text-[var(--text)]">admin@pncunique.com</strong>. If you receive a message that looks
              suspicious, do not enter your details — contact us using the details above to verify it first.
            </p>
          </div>
        </div>
      </div>
    </LegalShell>
  );
}
